import { render, staticRenderFns } from "./AppointmentTypeModal.vue?vue&type=template&id=7372a5e1"
import script from "./AppointmentTypeModal.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports